import styled from '@emotion/styled';
import { MenuItemsNavigation } from 'src/components/Menu/Menu.style';

export const MenuItemsNavigationCasino = styled(MenuItemsNavigation, { label: 'MenuItemsNavigationCasino' })`
    flex: 0 0 248px;
    width: 248px;
`;
